/**
 * Client service for Hospital Starter Templates Status.
 * R39 C5.a1 (plan docs/plans/sector-operations.md §2 SO-P252, H§5).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'

export interface GetHosStarterStatusInput {
  workspaceId: string
  placeId?: string
}

export interface HosStarterTemplateStatus {
  starterKey: string
  slug: string
  name: string
  templateId: string
  currentVersion: number
  edition: string
  edited: boolean
  exists: boolean
}

export interface GetHosStarterStatusResult {
  templates: HosStarterTemplateStatus[]
}

export async function getHosStarterStatus(
  input: GetHosStarterStatusInput,
): Promise<GetHosStarterStatusResult> {
  return callable<GetHosStarterStatusInput, GetHosStarterStatusResult>('getHosStarterStatus', input)
}
